import React, { useRef } from 'react';

import ModalVideo from '../ModalVideo';
import { Lila_Title } from '../../../../../utils/EN/Modals/VideoModals';

const ModalVideoLila = () => {
  return (
    <>
      <ModalVideo
        id="lila-videoclips"
        dataText={Lila_Title}
        videoSrc="https://player.vimeo.com/video/123680741?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
        videoTitle="KUTER_STUDIO_LILA"
      />
    </>
  );
};

export default ModalVideoLila;
